import { IDiagLabPanel } from 'app/shared/model/diag-lab-panel.model';
import { IDiaglabBill } from 'app/shared/model/diaglab-bill.model';
import { IDiaglabPricing } from 'app/shared/model/diaglab-pricing.model';
import { IUserLabTestItem } from 'app/shared/model/user-lab-test-item.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface IDiaglabBillItem {
  id?: string;
  price?: number;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  statusCode?: string | null;
  cancelledReason?: string | null;
  discount?: number | null;
  paidAmount?: number | null;
  groupPanelId?: string | null;
  panel?: IDiagLabPanel | null;
  diaglabBill?: IDiaglabBill | null;
  diaglabPricing?: IDiaglabPricing | null;
  labTestItem?: IUserLabTestItem;
  scheme?: IPaymentScheme | null;
  accessEntry?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IDiaglabBillItem> = {
  active: false,
};
